import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MdOutlineDeleteOutline } from "react-icons/md";

const MySwal = withReactContent(Swal);

const DeleteSwal = ({
  entity = "Item",
  title,
  text,
  note,
  icon: Icon = MdOutlineDeleteOutline, // 👈 icon prop
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  onConfirm,
  cancleColor = "#FFEFEB",
  confirmColor = "#FF6943",
}) => {
  MySwal.fire({
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: confirmColor,
    cancelButtonColor: cancleColor,
    reverseButtons: true,
    focusCancel: true,

    didOpen: () => {
      const icon = document.getElementById("swal-icon");
      if (icon) icon.classList.add("shake-icon");
    },

    html: (
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="w-14 h-14 rounded-full bg-[#FF6943] flex items-center justify-center">
          <Icon size={30} className="text-white" id="swal-icon" />
        </div>

        <h2 className="text-lg font-semibold text-[#FF6943]">
          {title || `Delete ${entity}?`}
        </h2>

        <p className="text-sm text-gray-600">
          {text ||
            `Are you sure you want to delete this ${entity.toLowerCase()}?`}
        </p>

        <div className="text-xs text-[#FF4A4A]">{note}</div>
      </div>
    ),
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm?.();
    }
  });
};

export default DeleteSwal;